import { AttachmentField } from 'modules/attachments/AttachmentField';
import { TextField, IntField, SelectField, DatePickerField } from '@ff-it/form';
import { agreementKindOptions } from 'configuration';
import { ReactElement } from 'react';
export function Form(): ReactElement {
  return (
    <div className="container px-0 ml-0">
      <div className="form-row">
        <TextField name="number" label="Number" className="col-md-3" help="Leave blank to assign" />
        <SelectField label="Kind" name="kind" options={agreementKindOptions} simple required className="col-md-3" />
        {/* unterminatd period */}
        <DatePickerField label="Date from" name="date_from" required className="col-2" />
        <DatePickerField label="Date to" name="date_to" className="col-2" />
        {/* /<DateRangePickerField label="Period" fromName="date_from" toName="date_to" className="col-md-3" required /> */}
        <IntField label="Invoice payment days" name="invoice_payment_days" className="col-md-2" />
      </div>
      <div className="form-row">
        <div className="col-md-6">
          <AttachmentField name="attachments" label="Attachments" />
        </div>
        <div className="col-md-6"></div>
      </div>

      <div className="form-row">
        <TextField
          name="terms"
          className="col-6"
          label="Terms and conditions"
          multiline
          help="General terms and conditions"
        />
        <TextField name="notes" className="col-6" label="Notes" multiline help="Private notes for internal use" />
      </div>
    </div>
  );
}
